import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initAnimation(
    root: HTMLElement,
    image: HTMLElement,
    messages: HTMLElement,
    onAnimationStart: () => void,
    onAnimationComplete: () => void,
) {
    gsap.fromTo(
        root,
        { scale: 0.2, opacity: 0 },
        {
            scrollTrigger: {
                trigger: root,
                start: 'top center-=40%',
                end: 'bottom center-=45%',
                scrub: true,
                // markers: true,
            },
            scale: 1,
            opacity: 1,
            onStart: () => {
                onAnimationStart();
                image.style.opacity = '1';
                messages.style.opacity = '0';
            },
            onComplete: () => {
                setTimeout(() => {
                    onAnimationComplete();
                    image.style.opacity = '0';
                    messages.style.opacity = '1';
                }, 1000);
            },
        },
    );
}
